import { Injectable } from '@angular/core';
import { GetUserExtendedAttributeValuePipe } from 'app/projects/shared/src/lib/pipes/getUserExtendedAttributeValue.pipe';
import { UserExtendedAttributeWithValue } from 'app/projects/user/src/lib/models/user-attribute-with-value';
import { IApplyKeywordsToTextContext } from '../interfaces/apply-keywords-to-text-context.interface';

@Injectable()
export class ApplyKeywordsToTextService {
    private readonly _extendedAttributePattern = '%ext_[A-Za-z0-9_]+%';
    private readonly _extendedAttributeNameStartIndex = 5;

    constructor(private _getUserExtendedAttributeValuePipe: GetUserExtendedAttributeValuePipe) {}

    apply(text: string, context: IApplyKeywordsToTextContext): string {
        if (!text || !context.user) {
            return text;
        }

        const { user, module } = context;
        let result = text;

        const staticKeywords = [
            { keyword: '%first_name%', value: user.firstName },
            { keyword: '%last_name%', value: user.lastName },
            { keyword: '%email%', value: user.email },
            { keyword: '%user_id%', value: user.id },
            { keyword: '%user_language%', value: user.language },
            { keyword: '%module_id%', value: module?.id },
            { keyword: '%module_name%', value: module?.name || '' },
        ];

        staticKeywords.forEach(({ keyword, value }) => {
            result = result.split(keyword).join(value ?? '');
        });

        result = this._replaceExtendedAttributeKeywords(result, [
            user.attributes,
            module?.attributes ?? [],
            module?.courseOffering?.attributes ?? [],
        ]);

        return result;
    }

    private _replaceExtendedAttributeKeywords(text: string, attributeCollections: UserExtendedAttributeWithValue[][]): string {
        return text.replace(new RegExp(this._extendedAttributePattern, 'g'), (match) => {
            const attributeName = match.substring(this._extendedAttributeNameStartIndex, match.length - 1);

            for (const attributes of attributeCollections) {
                const attributeWithValue = attributes.find((attr) => attr.attribute.name === attributeName);

                if (!attributeWithValue) {
                    continue;
                }

                const attributeValue = this._getUserExtendedAttributeValuePipe.transform(attributeWithValue.attribute, attributes) as string;

                if (attributeValue) {
                    return attributeValue;
                }
            }

            return '-';
        });
    }
}
